import React from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const getTracesSampleRate = () => {
  const configuredRate = Number(
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE
  );
  const defaultRate = process.env.NODE_ENV === "production" ? 0.1 : 1.0;

  return Number.isFinite(configuredRate) &&
    configuredRate >= 0 &&
    configuredRate <= 1 &&
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE !== ""
    ? configuredRate
    : defaultRate;
};

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [
      Sentry.reactRouterBrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: getTracesSampleRate(),
    enableLogs: true,
    sendDefaultPii: false,
  });
} else if (process.env.NODE_ENV === "development") {
  console.warn(
    "Sentry is disabled because REACT_APP_SENTRY_DSN is not configured in the frontend environment."
  );
}

export { getTracesSampleRate };
